export enum FormEditModeRF {
    CadastrarNova = 'cadastrar-nova',
    CadastrarTemplate = 'cadastrar-template',
    Editar = 'editar',
    Visualizar = 'visualizar',
    Clonar = 'clonar',
}
